import { createAction } from '@reduxjs/toolkit';
import type { AccountType } from 'app-components/flux/accounts/accountsTypes';
import type { resourceStoreTypes } from 'app-components/flux/core';
import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { FundingAccount, FundingAccountProps, VerifyMicrodepositsPayload } from './types';

const fundingAccountPayloadCreator = getPayloadCreator<{
  fundingAccount: FundingAccountProps | FundingAccount;
  userSetAccountType: AccountType;
}>();
const fundingAccountRecordPayloadCreator = getPayloadCreator<FundingAccount>();

export const getFundingAccounts = createAction('GET_FUNDING_ACCOUNTS', getPayloadCreator());
export const getFundingAccountsSuccess =
  createAction<resourceStoreTypes.QcsSyncResourcesPayload<FundingAccountProps>>('GET_FUNDING_ACCOUNTS_SUCCESS');

export const getFundingAccountsFailure = createAction('GET_FUNDING_ACCOUNTS_FAILURE', errorPayloadCreator);

export const createFundingAccount = createAction('CREATE_FUNDING_ACCOUNT', fundingAccountPayloadCreator);
export const createFundingAccountSuccess = createAction(
  'CREATE_FUNDING_ACCOUNT_SUCCESS',
  fundingAccountRecordPayloadCreator,
);
export const createFundingAccountFailure = createAction('CREATE_FUNDING_ACCOUNT_FAILURE', errorPayloadCreator);

export const confirmFundingAccount = createAction('CONFIRM_FUNDING_ACCOUNT', fundingAccountRecordPayloadCreator);
// export const confirmFundingAccountSuccess?
export const confirmFundingAccountFailure = createAction('CONFIRM_FUNDING_ACCOUNT_FAILURE', errorPayloadCreator);

// currently there is no update endpoint
// export const updateFundingAccount = createAction('UPDATE_FUNDING_ACCOUNT', fundingAccountPayloadCreator);
// export const updateFundingAccountSuccess = createAction('UPDATE_FUNDING_ACCOUNT_SUCCESS');
// export const updateFundingAccountFailure = createAction('UPDATE_FUNDING_ACCOUNT_FAILURE', errorPayloadCreator);

// delete has potential to be hairy since multiple quicken products can leverage the same funding account
// - only do this in failed verification states, for 'disable transfers' case we can just clear fundingAccountId from account record
export const deleteFundingAccount = createAction(
  'DELETE_FUNDING_ACCOUNT',
  getPayloadCreator<{ id: string; isDeleted: true }>(),
);
export const deleteFundingAccountSuccess = createAction(
  'DELETE_FUNDING_ACCOUNT_SUCCESS',
  fundingAccountRecordPayloadCreator,
);
export const deleteFundingAccountFailure = createAction('DELETE_FUNDING_ACCOUNT_FAILURE', errorPayloadCreator);

//  Initiate
// export const initiateMicroDepositsAction = createAction('INITIATE_MICRO_DEPOSIT_ACTION', getPayloadCreator());
// export const initiateMicroDepositsActionSuccess = createAction('INITIATE_MICRO_DEPOSIT_ACTION_SUCCESS');
// export const initiateMicroDepositsActionFailure = createAction('INITIATE_MICRO_DEPOSIT_ACTION_FAILURE');

//  Verify
export const verifyMicroDepositsAction = createAction(
  'VERIFY_MICRO_DEPOSIT_ACTION',
  getPayloadCreator<VerifyMicrodepositsPayload>(),
);
// export const verifyMicroDepositsActionSuccess = createAction('VERIFY_MICRO_DEPOSIT_ACTION_SUCCESS', getPayloadCreator());
export const verifyMicroDepositsActionFailure = createAction<unknown>('VERIFY_MICRO_DEPOSIT_ACTION_FAILURE');
